import React, { Fragment } from 'react';

export default {
  title: <Fragment><strong>Gauland</strong><span>-Phase</span></Fragment>,
  duration: 'April 2017 - heute',
  startDate: new Date(2017, 3, 23),
  endDate: new Date(2019, 7, 30),
  description: 'Etablierung der „Völkischen“',
  description_long: 'Gauland steigt zur wichtigsten Leitfigur der Partei auf - auch dank des „Flügel“. Ohne die völkische Gruppierung um Höcke geht nichts mehr. Parteichef Galaund lässt die Zügel meist locker, greift nur ein, wenn er muss. Doch auch er kann nicht verhindern, dass harte Flügelkämpfe wieder aufbrechen.',
  items: [{
    milestone: true,
    coords: {
      x: new Date(2017, 8, 24),
      y: 13
    },
    coordsMobile: {
      x: new Date(2017, 8, 24),
      y: 13
    },
    title: 'AfD wird drittstärkste Kraft bei Bundestagswahl',
    kicker: '24. September 2017',
    text:
      <p>
        <span className="media">
          <img src="images/chronik/3-2017-09-Bundestagswahl_dpa.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption">Die Spitzenkandidaten Gauland (l.) und Weidel bei der AfD-Wahlparty</span>
            <span className="media-credit">dpa/picture alliance</span>
          </span>
        </span>
        Erstmals seit den 50er-Jahren zieht eine Partei rechts von CDU/CSU in den Bundestag ein.
        Laut einer Umfrage (Infratest-Dimap) war Migration bei der Wahl das wichtigste Thema der Deutschen. Die AfD wird mit 12,6 Prozent die drittstärkste Kraft und kommt auf 94 Sitze.
        Nur einen Tag danach kündigt Noch-Parteichefin Petry an, der Fraktion nicht angehören zu wollen - und tritt wenig später aus der AfD aus.
        AfD-Strippenzieher Gauland wird später, im Dezember, auch offiziell Partei-Chef, neben Meuthen.

      </p>,
    additional: <p><strong>Bundestagswahl:</strong> 12,6 Prozent</p>
  }, {
    milestone: false,
    coords: {
      x: new Date(2018, 2, 14),
      y: 14.7
    },
    coordsMobile: {
      x: new Date(2018, 2, 14),
      y: 14.5
    },
    kicker: '14. März 2018',
    title: 'Groko nimmt Arbeit auf - gebremst vor der Bayernwahl',
    text:
    <p>
        Fast ein halbes Jahr vergeht, bis die neue Bundesregierung ihre Arbeit aufnimmt. Nach gescheiterten Jamaika-Verhandlungen ist es wieder eine große Koalition.
        Doch die im Oktober bevorstehende Bayern-Wahl wird die Arbeit ausbremsen. Mit der Schwäche dieser „Notlösung“ Groko steigt auch die AfD in den Umfragen.
      </p>
  }, {
    milestone: false,
    coords: {
      x: new Date(2018, 6, 1),
      y: 16
    },
    coordsMobile: {
      x: new Date(2018, 6, 1),
      y: 16.1
    },
    kicker: '1. Juli',
    title: 'Asylstreit eskaliert - Seehofer kündigt Rücktritt an',
    text:
      <p>
        Horst Seehofer kündigt seinen Rücktritt als Bundesinnenminister und als CSU-Chef an. Grund: der Asylstreit zwischen CSU und CDU. 
        Seehofer will in anderen EU-Staaten registrierte Geflüchtete an deutschen Grenzen abweisen. Bundeskanzlerin Angela Merkel warnt ihn vor einem Alleingang. 
        Der Streit eskaliert zu einer handfesten Regierungskrise. Der Innenminister tritt zwar bereits am 2. Juli vom Rücktritt zurück und beide Seiten verkünden einen Kompromiss. 
        Das Thema wird aber den politischen Sommer bestimmen.
      </p>
  }, {
    milestone: true,
    coords: {
      x: new Date(2018, 8, 1),
      y: 17
    },
    coordsMobile: {
      x: new Date(2018, 8, 1),
      y: 17.2
    },
    kicker: '1. September 2018',
    title: 'Höcke marschiert mit Neonazis in Chemnitz',
    text:
      <p>
        <span className="media">
          <img src="images/chronik/3-2018-04_Chemnitz-Hoecke_dpa.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption">Höcke in Chemnitz, hinter ihm: Pegida-Gründer Lutz Bachmann</span>
            <span className="media-credit">dpa/picture alliance</span>
          </span>
        </span>
        Die AfD führt einen sogenannten „Schweigemarsch“ in Chemnitz an, ganz vorn dabei drei AfD-Landeschefs: Björn Höcke (Thüringen), Jörg Urban (Sachsen) und Andreas Kalbitz (Brandenburg). 
        Alle sind heute zugleich die Spitzenkandidaten für die bevorstehenden Landtagswahlen 2019 im Osten. Sie marschieren zusammen mit der fremdenfeidlichen Pegida, der rechtsradikalen Vereinigung Pro Chemnitz sowie zahlreichen Neonazis.
        Die AfD erzielt zu dieser Zeit ihre bundesweit bislang höchsten Umfragewerte. Doch Chemnitz markiert zugleich einen Wendepunkt für die Partei in den Umfragen.
      </p>,
    additional: <p><strong>Umfrage-Hoch:</strong> 17 (mehrere) bis 19&nbsp;Prozent (Insa)</p>
  }, {
    milestone: true,
    coords: {
      x: new Date(2019, 0, 15),
      y: 12.3
    },
    coordsMobile: {
      x: new Date(2019, 0, 15),
      y: 12.3
    },
    kicker: '15. Januar 2019',
    title: 'Verfassungschutz nimmt AfD öffentlich ins Visier',
    text:
    <p>
        Nachdem Verfassungsschutz-Präsident Hans-Georg Maaßen in den einstweiligen Ruhestand versetzt wurde, bläst der AfD nun Gegenwind von der Behörde zu:
        Das Bundesamt für Verfassungsschutz erklärt die gesamte AfD zu einem „Prüffall“ und die innerparteiliche Bewegung um Höcke „Der Flügel“ sowie die Jugendorganisation Junge Alternative zu „Verdachtsfällen“.
        Die AfD wehrt sich gerichtlich mit Erfolg gegen die Bezeichnung „Prüffall“: Der Verfassungsschutz spricht seit März nicht mehr davon - prüft aber weiter.
      </p>
  }, {
    milestone: false,
    coords: {
      x: new Date(2019, 4, 26),
      y: 12.3
    },
    coordsMobile: {
      x: new Date(2019, 4, 26),
      y: 12.3
    },

    kicker: '26. Mai 2019',
    title: 'Europawahl: AfD stagniert im Westen - boomt aber im Osten',
    text:
    <p>
        Die AfD schneidet bei der Europawahl insgesamt schlechter ab als erwartet. Mit 11 Prozent bleibt sie unter dem Ergebnis der Bundestagswahl. 
        Das bestimmende Thema in der politischen Debatte ist nicht mehr die Migration, sondern seit den Schülerprotesten der „Fridays for Future“-Bewegung der Klimawandel.
        Doch während die AfD im Westen meist einstellig bleibt, ist sie in vielen Kreisen Ostdeutschlands stärkste Kraft. 
        Drei Monate später wird sie in Sachsen mit 27,5 Prozent ihr bundesweit bislang stärkstes Ergebnis bei Landtagswahlen holen.

      </p>,
    additional: <p><strong>Europawahl:</strong> 11 Prozent</p>
  }]
};